
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';
import ProductCard from '../../components/base/ProductCard';
import { updateSEO, seoData, getBaseURL } from '../../utils/seo';

export default function AccessoriesPage() {
  const [selectedFilter, setSelectedFilter] = useState('Todos');
  const [sortBy, setSortBy] = useState('Relevância');

  useEffect(() => {
    updateSEO({
      ...seoData.accessories,
      canonical: `${getBaseURL()}/accessories`,
      ogTitle: seoData.accessories.title,
      ogDescription: seoData.accessories.description,
      ogImage: `${getBaseURL()}/og-image.jpg`
    });
  }, []);

  const filters = ['Todos', 'Óculos', 'Cintos', 'Joias', 'Bonés', 'Gravatas'];
  const sortOptions = ['Relevância', 'Menor Preço', 'Maior Preço', 'Mais Novos'];

  const products = [
    {
      id: '1',
      image: 'https://public.readdy.ai/ai/img_res/2c95dbadfe6d2548072deb9abadbbb33.jpg',
      brand: 'DLUXMEN',
      name: 'Óculos Premium Aviador',
      price: 'R$ 299,90',
      originalPrice: 'R$ 399,90',
      isNew: true
    },
    {
      id: '2',
      image: 'https://readdy.ai/api/search-image?query=luxury%20leather%20belt%20premium%20quality%20with%20sophisticated%20buckle%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20belt%20with%20emerald%20green%20brand%20details%2C%20high-end%20craftsmanship&width=400&height=500&seq=dluxmen-belt-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Cinto Couro Italiano',
      price: 'R$ 189,90',
      isNew: true
    },
    {
      id: '3',
      image: 'https://readdy.ai/api/search-image?query=luxury%20jewelry%20premium%20gold%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20jewelry%20piece%20with%20emerald%20green%20brand%20accents%2C%20high-end%20quality%20materials&width=400&height=500&seq=dluxmen-jewelry-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Corrente Premium Gold',
      price: 'R$ 449,90',
      originalPrice: 'R$ 599,90'
    },
    {
      id: '4',
      image: 'https://readdy.ai/api/search-image?query=luxury%20cap%20premium%20materials%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20cap%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality%20craftsmanship&width=400&height=500&seq=dluxmen-cap-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Boné Premium Edition',
      price: 'R$ 129,90'
    },
    {
      id: '5',
      image: 'https://readdy.ai/api/search-image?query=luxury%20tie%20premium%20silk%20with%20sophisticated%20pattern%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20necktie%20with%20emerald%20green%20brand%20accents%2C%20high-end%20quality%20materials&width=400&height=500&seq=dluxmen-tie-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Gravata Seda Premium',
      price: 'R$ 159,90',
      isNew: true
    },
    {
      id: '6',
      image: 'https://readdy.ai/api/search-image?query=luxury%20cufflinks%20premium%20metal%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20cufflinks%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality&width=400&height=500&seq=dluxmen-cufflinks-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Abotoaduras Luxury',
      price: 'R$ 249,90',
      originalPrice: 'R$ 329,90'
    },
    {
      id: '7',
      image: 'https://readdy.ai/api/search-image?query=luxury%20scarf%20premium%20silk%20with%20sophisticated%20pattern%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20scarf%20with%20emerald%20green%20brand%20accents%2C%20high-end%20quality%20materials&width=400&height=500&seq=dluxmen-scarf-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Lenço Seda Premium',
      price: 'R$ 179,90'
    },
    {
      id: '8',
      image: 'https://readdy.ai/api/search-image?query=luxury%20ring%20premium%20metal%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20ring%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality%20craftsmanship&width=400&height=500&seq=dluxmen-ring-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Anel Premium Collection',
      price: 'R$ 219,90',
      originalPrice: 'R$ 289,90'
    }
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F8F8', fontFamily: 'Montserrat, sans-serif' }}>
      <Header />

      {/* Page Header */}
      <section className="pt-24 pb-8" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <h1 
            className="text-5xl font-bold mb-4 max-md:text-3xl"
            style={{ 
              fontFamily: 'Cinzel Decorative, serif',
              color: '#0B0B0B'
            }}
          >
            Accessories
          </h1>
          <p 
            className="text-lg max-md:text-base"
            style={{ 
              color: '#C0C0C0',
              fontFamily: 'Montserrat, sans-serif'
            }}
          >
            Acessórios premium para completar seu look com elegância
          </p>
        </div>
      </section>

      {/* Filters and Sort */}
      <section className="py-6 border-b" style={{ backgroundColor: '#F8F8F8', borderColor: '#C0C0C0' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between space-y-4 md:space-y-0">
            {/* Filters */}
            <div className="flex items-center space-x-6 overflow-x-auto pb-2 max-md:space-x-4">
              {filters.map((filter) => (
                <button
                  key={filter}
                  onClick={() => setSelectedFilter(filter)}
                  className={`text-sm font-medium uppercase tracking-wide whitespace-nowrap pb-2 border-b-2 transition-all duration-200 ${
                    selectedFilter === filter 
                      ? 'border-green-800 text-green-800' 
                      : 'border-transparent text-gray-600 hover:text-green-800'
                  }`}
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {filter}
                </button>
              ))}
            </div>

            {/* Sort */}
            <div className="flex items-center space-x-2">
              <span 
                className="text-sm font-medium"
                style={{ 
                  color: '#C0C0C0',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                Ordenar por:
              </span>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="text-sm font-medium border-none bg-transparent focus:outline-none pr-8"
                style={{ 
                  color: '#0B0B0B',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                {sortOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-12" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-md:gap-4">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                {...product}
                onClick={() => {
                  console.log('Produto clicado:', product.name);
                }}
              />
            ))}
          </div>

          {/* Load More */}
          <div className="text-center mt-12">
            <button
              className="px-8 py-3 font-semibold text-white rounded-lg transition-all duration-300 hover:bg-green-700"
              style={{ 
                backgroundColor: '#0F3F2F',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Carregar Mais Produtos
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
